const initialState = {
  error: {},
  loading: false,
  leaseAction: null,
};

const NOTICE_VACATE_REDUCER = (state = initialState, { type, payload }) => {
  switch (type) {
    case "NOTICE_VACATE_LOADING": {
      return {
        ...state,
        loading: true,
      };
    }
    case "NOTICE_VACATE_LOADING_START": {
      return {
        ...state,
        loading: true,
      };
    }
    case "NOTICE_VACATE_LOADING_STOP": {
      return {
        ...state,
        loading: false,
      };
    }
    case "GET_LEASE_ACTION_STATE": {
      return {
        ...state,
        leaseAction: payload,
      };
    }
    case "GET_LEASE_ACTION_STATE_ERROR": {
      return {
        ...state,
        leaseAction: null,
      };
    }
    default:
      return state;
  }
};

export default NOTICE_VACATE_REDUCER;
